import * as React from "react";

interface MetaDataGroupProps {
  name: string;
  items: Array<Metadata>;
}

export class MetadataGroup extends React.Component<MetaDataGroupProps, {}> {
  render() {
    return (
      <>
        <div className="metadata-group full-width">
          <div className="metadata-group-title">{this.props.name}</div>
          <table className="metadata-group-values">
            <tbody>
              {this.props.items.map((it) => (
                <tr key={it.key}>
                  <td className="metadata-key">{it.key}</td>
                  <td className="metadata-value">{it.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  }
}
